import Api from '@/api'

const api = new Api()
const apiAdjustment = api.adjustment()

export default {
  async updateMondayCustomers({ commit }) {
    try {
      await apiAdjustment.monday().customers()
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async updateProjectStatus({ commit }) {
    try {
      const { data } = await apiAdjustment.monday().projectStatus()

      const updatedProjects = data.data.updated

      if (updatedProjects.length === 0) {
        commit('Dashboard/setFeedback', { message: 'Nothing to update' }, { root: true })
      } else {
        commit('Dashboard/setFeedback', { message: updatedProjects.join('<br />') }, { root: true })
      }
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async updateUsers({ commit }) {
    try {
      await apiAdjustment.monday().updateUsers()
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
